/* ============================================================
   BioActive+ — Shop All — Dawn theme behaviour (vanilla JS)
   - Accordion (science section)
   - Quiz modal (goal -> mode -> recommended product)
   - Add to cart via Shopify AJAX Cart API (/cart/add.js)
   - Sticky cart bar bound to the live cart (/cart.js)
   No dependencies. Safe to defer.
   ============================================================ */
(function () {
  "use strict";

  var BUNDLE_TIERS = [{ n: 8, pct: 30 }, { n: 4, pct: 20 }, { n: 2, pct: 10 }];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents, currency) {
    var n = Math.round((cents || 0) / 100);
    return n.toLocaleString("en-US") + " " + (currency || "AED");
  }

  /* ---------------- toast ---------------- */
  var toastEl, toastTimer;
  function toast(msg) {
    toastEl = toastEl || $("[data-sa-toast]");
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    toastEl.classList.add("sa-toast");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2200);
  }

  /* ---------------- accordion ---------------- */
  function initAccordion() {
    $all("[data-sa-accordion] .sa-learn-item").forEach(function (item) {
      var btn = $(".sa-learn-q", item);
      if (!btn) return;
      btn.addEventListener("click", function () {
        var open = item.classList.contains("open");
        $all("[data-sa-accordion] .sa-learn-item").forEach(function (i) {
          i.classList.remove("open");
          var b = $(".sa-learn-q", i); if (b) b.setAttribute("aria-expanded", "false");
        });
        if (!open) { item.classList.add("open"); btn.setAttribute("aria-expanded", "true"); }
      });
    });
  }

  /* ---------------- cart ---------------- */
  function getCart() { return fetch(ROOT + "cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }

  function addToCart(variantId, qty) {
    var hasBioactiveDrawer = !!document.querySelector("[data-bac-drawer-host]");
    var hasDawnDrawer = !!document.querySelector("cart-drawer");
    var body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (hasBioactiveDrawer) {
      body.sections = "bioactive-cart-drawer";
      body.sections_url = window.location.pathname;
    } else if (hasDawnDrawer) {
      body.sections = "cart-drawer,cart-icon-bubble";
      body.sections_url = window.location.pathname;
    }

    return fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || (data && data.status)) throw data;
        return data;
      });
    });
  }

  function clearCart() {
    return fetch(ROOT + "cart/clear.js", { method: "POST", headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
  }

  function openCart() {
    // Prefer the theme's cart drawer; fall back to the cart page.
    var bubble = document.querySelector("#cart-icon-bubble") || document.querySelector('a[href$="/cart"]');
    var drawer = document.querySelector("cart-drawer");
    if (drawer && bubble) { bubble.click(); return; }
    window.location.href = ROOT + "cart";
  }

  function applyDawnSection(name, html) {
    if (!html) return;
    var selector = name === "cart-icon-bubble" ? "#cart-icon-bubble" : (name === "cart-drawer" ? "cart-drawer" : null);
    if (!selector) return;
    var current = document.querySelector(selector);
    if (!current) return;
    var tmp = document.createElement("div");
    tmp.innerHTML = html;
    var fresh = tmp.querySelector(selector);
    if (fresh) current.innerHTML = fresh.innerHTML;
  }

  function applyCartSections(sections) {
    if (!sections) return;
    if (typeof window.__bacApplySections === "function") {
      window.__bacApplySections(sections);
      return;
    }
    Object.keys(sections).forEach(function (name) { applyDawnSection(name, sections[name]); });
  }

  function openFreshCart(addResponse) {
    if (addResponse && addResponse.sections) applyCartSections(addResponse.sections);

    if (typeof window.__bacOpenDrawer === "function") {
      window.__bacOpenDrawer();
      return;
    }

    var bacHost = document.querySelector("[data-bac-drawer-host]");
    if (bacHost) {
      bacHost.classList.add("is-open");
      document.body.style.overflow = "hidden";
      document.documentElement.classList.add("bac-open");
      return;
    }

    var dawnDrawer = document.querySelector("cart-drawer");
    if (dawnDrawer) {
      dawnDrawer.classList.remove("is-empty");
      if (addResponse && addResponse.sections && typeof dawnDrawer.renderContents === "function") {
        dawnDrawer.renderContents(addResponse);
      } else if (typeof dawnDrawer.open === "function") {
        dawnDrawer.open();
      }
      return;
    }

    openCart();
  }

  /* ---------------- sticky bar ---------------- */
  var bar;
  function nextTier(count) {
    if (count >= 4) return null;
    if (count >= 2) return { boxes: "4 boxes", pct: 20, more: 4 - count };
    return { boxes: "2 boxes", pct: 10, more: (count < 1 ? 2 : 2 - count) };
  }

  function renderBar(cart) {
    bar = bar || $("[data-sa-stickybar]");
    if (!bar) return;
    var count = cart.item_count || 0;
    if (count < 1) { bar.hidden = true; bar.classList.remove("show"); return; }
    bar.hidden = false; bar.classList.add("show");

    // count badge
    var ct = $("[data-sa-count]", bar);
    if (ct) { ct.hidden = false; ct.textContent = count; }

    // vials: one thumb per box up to 4, then +N
    var vials = $("[data-sa-vials]", bar);
    if (vials) {
      var thumbs = [];
      cart.items.forEach(function (it) { for (var i = 0; i < it.quantity; i++) thumbs.push(it); });
      var shown = thumbs.slice(0, 4), extra = count - shown.length;
      vials.innerHTML = shown.map(function (it) {
        var img = it.featured_image && it.featured_image.url ? it.featured_image.url : (it.image || "");
        return '<span class="sa-sb-vial">' + (img ? '<img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : "") + "</span>";
      }).join("") + (extra > 0 ? '<span class="sa-sb-more">+' + extra + "</span>" : "");
    }

    // title + meta
    var title = $("[data-sa-title]", bar);
    if (title) title.textContent = count + (count === 1 ? " box" : " boxes") + " in your cart";
    var meta = $("[data-sa-meta]", bar);
    if (meta) {
      var nt = nextTier(count);
      meta.textContent = nt ? ("Add " + nt.more + " more box" + (nt.more > 1 ? "es" : "") + " for " + nt.pct + "% off") : "Max bundle discount unlocked";
    }
    // promo strip tier
    var tierEl = $("[data-sa-tier]", bar);
    if (tierEl) { var nt2 = nextTier(count); tierEl.innerHTML = nt2 ? ("<b>" + nt2.boxes + "</b> · " + nt2.pct + "% off") : "<b>30% off</b> unlocked"; }

    // total (live cart total)
    var total = $("[data-sa-total]", bar);
    if (total) total.innerHTML = money(cart.total_price, cart.currency) ;
  }

  function refreshBar() { return getCart().then(renderBar); }

  /* ---------------- product card counts (legacy badges) ---------------- */
  function refreshCounts(cart) {
    var map = {};
    cart.items.forEach(function (it) { map[it.variant_id] = (map[it.variant_id] || 0) + it.quantity; });
    $all("[data-sa-count]").forEach(function (el) {
      var vid = el.getAttribute("data-sa-count");
      if (!vid) return;
      var n = map[vid] || 0;
      if (n > 0) { el.hidden = false; el.textContent = n; } else { el.hidden = true; }
    });
  }

  /* ---------------- add-to-cart buttons ---------------- */
  function initAddButtons() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-sa-add]");
      if (!btn) return;
      /* Grid cards (.sa-card-add) run their OWN add flow in the grid section
         script (busy-guarded, opens the drawer, updates mini-cart chips).
         Handling them here too fired /cart/add.js TWICE per click. */
      if (btn.classList.contains("sa-card-add")) return;
      e.preventDefault();
      var vid = btn.getAttribute("data-sa-add");
      if (!vid) return;
      if (btn.dataset.saBusy) return;
      btn.dataset.saBusy = "1";
      btn.disabled = true;
      addToCart(vid, 1).then(function () {
        return getCart();
      }).then(function (cart) {
        renderBar(cart); refreshCounts(cart);
        toast((btn.getAttribute("data-sa-name") || "Item") + " added to cart");
        document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
      }).catch(function () { toast("Could not add to cart"); })
        .finally(function () { btn.disabled = false; delete btn.dataset.saBusy; });
    });

    var clearBtn = $("[data-sa-clear]");
    if (clearBtn) clearBtn.addEventListener("click", function () {
      clearCart().then(refreshBar).then(function () { toast("Cart cleared"); });
    });

    $all("[data-sa-viewcart]").forEach(function (b) { b.addEventListener("click", openCart); });
  }

  /* ---------------- quiz ---------------- */
  function initQuiz() {
    var scrim = $("[data-sa-quiz]");
    if (!scrim) return;
    var state = { goal: null, mode: "onetime" };
    var steps = $all("[data-sa-step]", scrim);
    var result = $("[data-sa-result]", scrim);
    var dots = $all("[data-sa-quiz-prog] .d", scrim);

    function show(stepIdx, showResult) {
      steps.forEach(function (s) { s.hidden = String(s.getAttribute("data-sa-step")) !== String(stepIdx) || showResult; });
      result.hidden = !showResult;
      dots.forEach(function (d, i) { d.classList.toggle("on", showResult || i <= stepIdx); });
    }
    function open() { scrim.classList.add("show"); state = { goal: null, mode: "onetime" }; show(0, false); }
    function close() { scrim.classList.remove("show"); }

    $all("[data-sa-quiz-open]").forEach(function (b) { b.addEventListener("click", open); });
    $all("[data-sa-quiz-close]", scrim).forEach(function (b) { b.addEventListener("click", close); });
    scrim.addEventListener("click", function (e) { if (e.target === scrim) close(); });

    $all("[data-sa-goal]", scrim).forEach(function (b) {
      b.addEventListener("click", function () {
        state.goal = {
          variant: b.getAttribute("data-variant"), name: b.getAttribute("data-name"),
          img: b.getAttribute("data-img"), price: b.getAttribute("data-price"),
          desc: b.getAttribute("data-desc"), url: b.getAttribute("data-url")
        };
        state.mode = "onetime";
        renderResult();
      });
    });
    $all("[data-sa-mode]", scrim).forEach(function (b) {
      b.addEventListener("click", function () { state.mode = b.getAttribute("data-sa-mode"); renderResult(); });
    });
    var backBtn = $("[data-sa-back]", scrim); if (backBtn) backBtn.addEventListener("click", function () { show(0, false); });
    var restart = $("[data-sa-restart]", scrim); if (restart) restart.addEventListener("click", function () { show(0, false); });

    function renderResult() {
      var g = state.goal; if (!g) return;
      var img = $("[data-sa-result-img]", scrim);
      if (img) img.innerHTML = g.img ? '<img src="' + g.img + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : "";
      var nm = $("[data-sa-result-name]", scrim); if (nm) nm.textContent = g.name || "";
      var ds = $("[data-sa-result-desc]", scrim); if (ds) ds.textContent = g.desc || "";
      var pr = $("[data-sa-result-price]", scrim); if (pr) pr.textContent = (g.price || "") + (state.mode === "sub" ? "  ·  Subscribe & save 10%" : "");
      show(1, true);
      var add = $("[data-sa-result-add]", scrim);
      if (add) add.onclick = function () {
        if (!g.variant) { if (g.url) window.location.href = g.url; return; }
        add.disabled = true;
        addToCart(g.variant, 1).then(function (data) {
          close();
          openFreshCart(data);
          document.dispatchEvent(new CustomEvent("ba:cart:added", { detail: data }));
          return getCart();
        }).then(function (cart) {
          renderBar(cart); refreshCounts(cart); toast((g.name || "Item") + " added");
          document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
        }).catch(function (err) {
          toast((err && (err.description || err.message)) || "Could not add to cart");
        }).finally(function () { add.disabled = false; });
      };
    }
  }

  /* ---------------- boot ---------------- */
  function init() {
    initAccordion();
    initAddButtons();
    initQuiz();
    getCart().then(function (cart) { renderBar(cart); refreshCounts(cart); }).catch(function () {});
    // keep bar in sync if other scripts change the cart
    document.addEventListener("cart:updated", refreshBar);
    document.addEventListener("cart:refresh", refreshBar);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
